import clsx from 'clsx'
import type { Abbreviation } from '../types'

interface AbbreviationPanelProps {
  abbreviations: Abbreviation[]
  onUpdateMode: (abbreviationId: number, displayMode: 'short' | 'full' | 'both') => void
}

export default function AbbreviationPanel({
  abbreviations,
  onUpdateMode,
}: AbbreviationPanelProps) {
  if (!abbreviations || abbreviations.length === 0) {
    return null
  }

  const modeLabels: Record<string, string> = {
    short: 'Сокр.',
    full: 'Полн.',
    both: 'Оба',
  }

  const modeTooltips: Record<string, string> = {
    short: 'Только сокращение',
    full: 'Только расшифровка',
    both: 'Сокращение с расшифровкой при первом упоминании',
  }

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="font-semibold text-gray-800 mb-3">Аббревиатуры</h3>
      <div className="space-y-3">
        {abbreviations.map((abbr) => (
          <div
            key={abbr.id}
            className="flex items-start gap-3 p-2 rounded hover:bg-gray-50"
          >
            <div className="flex-1 min-w-0">
              <div className="font-medium text-purple-700">{abbr.short_form}</div>
              <div className="text-sm text-gray-600 truncate" title={abbr.expansion}>
                {abbr.expansion}
              </div>
              {abbr.segment_indices && abbr.segment_indices.length > 0 && (
                <div className="text-xs text-gray-400 mt-0.5">
                  Встречается: {abbr.segment_indices.length} раз
                </div>
              )}
            </div>
            <div className="flex gap-1">
              {(['short', 'full', 'both'] as const).map((mode) => (
                <button
                  key={mode}
                  onClick={() => onUpdateMode(abbr.id, mode)}
                  title={modeTooltips[mode]}
                  className={clsx(
                    'px-2 py-1 text-xs rounded transition',
                    abbr.display_mode === mode
                      ? 'bg-primary-500 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  )}
                >
                  {modeLabels[mode]}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-gray-100">
        <p className="text-xs text-gray-500">
          <strong>Сокр.</strong> — ВАК<br />
          <strong>Полн.</strong> — Высшая аттестационная комиссия<br />
          <strong>Оба</strong> — ВАК (Высшая аттестационная комиссия)
        </p>
      </div>
    </div>
  )
}
